import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { createBrowserRouter } from "react-router";
import { AppTree } from "./app/AppTree";
import { prefetchOrderScreens } from "./app/orderScreens";
import { createQueryClient } from "./app/queryClient";
import { routes } from "./app/routes";
import { chooseStartMode, reportHydrationMismatch, seedPrerenderedQueries } from "./prerender/clientStart";
import "./styles/fonts";
import "./styles/tokens.css";
import "./styles/base.css";
import { applyTelegramTheme, prepareTelegram } from "./telegram/telegram";

const rootElement = document.getElementById("root");
if (rootElement === null) {
  throw new Error("В странице нет элемента #root");
}

// В Mini App сначала скрипт Telegram и тема, потом приложение.
const webApp = await prepareTelegram();
if (webApp !== null) {
  applyTelegramTheme(webApp);
  // Mini App чаще всего открывается на заказе (telegram-continuity): код экранов заказа — сразу,
  // параллельно со входом через Telegram.
  prefetchOrderScreens();
}

const queryClient = createQueryClient();
const router = createBrowserRouter(routes);
const app = (
  <StrictMode>
    <AppTree router={router} queryClient={queryClient} webApp={webApp} />
  </StrictMode>
);

// Публичные страницы приходят готовыми (изменение seo): на сайте React подхватывает их разметку,
// в Mini App и на остальных экранах рисует с нуля.
if (chooseStartMode(rootElement, window.location.pathname, webApp !== null) === "hydrate") {
  seedPrerenderedQueries(queryClient, document);
  hydrateRoot(rootElement, app, { onRecoverableError: reportHydrationMismatch });
} else {
  // Без готовой разметки и без её пометки: иначе в Mini App корень остался бы спрятанным.
  rootElement.replaceChildren();
  delete rootElement.dataset.path;
  createRoot(rootElement).render(app);
}
